module.exports = __webpack_public_path__ + "static/media/lock.8640df80.svg";